<div class="modal-dialog-header">
    <h5 class="modal-title">{{ data?.title }}</h5>
    <button type="button" class="btn-close" (click)="onClose()"></button>
</div>

<div class="modal-dialog-body">
    <form>
        <div class="mb-3">
            <label for="counsellorSelect" class="form-label">Select Counsellor</label>
            <select class="form-control" id="counsellorSelect" [(ngModel)]="selectedCounsellor" name="counsellor">
        <option value="">-- Select Counsellor --</option>
        <option *ngFor="let counsellor of data?.counsellors" [value]="counsellor.refNo">
          {{ counsellor.userName }}
        </option>
      </select>
        </div>
    </form>
</div>

<div class="modal-dialog-footer">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
</div>